"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeRemovedBicyclesWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeRemovedBicyclesWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeRemovedBicyclesWidget, _super);
    function AnnualHomeRemovedBicyclesWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnualHomeRemovedBicyclesWidget.prototype.render = function () {
        if (this.props.interaction.bicycles != null) {
            var filteredOutBicycles = this.props.interaction.bicycles
                .filter(function (item) { return !item.flowValuable; })
                .filter(function (item) { return item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE; });
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: filteredOutBicycles.length > 0 &&
                    (0, jsx_runtime_1.jsx)("div", { className: "removed-item-info-panel font-weight-extra-light quote row mt-2 banner banner-info margin-x-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "p-0 d-flex col removed-valuable-item align-items-start", children: [(0, jsx_runtime_1.jsx)("div", { className: "removed-item-info-icon selected flex-start" }), (0, jsx_runtime_1.jsx)("div", { children: this.renderWording(filteredOutBicycles) })] }) }) }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    AnnualHomeRemovedBicyclesWidget.prototype.renderWording = function (filteredBicycles) {
        var aggregator = (0, commonFunctions_1.getAggregatorDisplayName)(this.props.interaction.source);
        var insideOnlyBicycles = filteredBicycles.filter(function (item) { return item.coverLocation === services_1.ValuableItemCoverLocation.HOME; });
        var cheapBicycles = filteredBicycles.filter(function (item) { return item.value <= 350 && item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE; });
        if (insideOnlyBicycles.length > 0 && cheapBicycles.length > 0) {
            var insideBicycleList = this.prepareDynamicProductListString(insideOnlyBicycles);
            var cheapBicycleList = this.prepareDynamicProductListString(cheapBicycles);
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["We have removed ", (0, jsx_runtime_1.jsx)("b", { children: insideBicycleList }), " you have listed on ", aggregator, " as you'll automatically be covered for bicycles inside your home."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["We have also removed ", (0, jsx_runtime_1.jsx)("b", { children: cheapBicycleList }), " you have listed on ", aggregator, " as you'll automatically get cover up to \u00A3350 for bicycles away from the home."] })] }));
        }
        else if (insideOnlyBicycles.length > 0) {
            var bicycleList = this.prepareDynamicProductListString(insideOnlyBicycles);
            return ((0, jsx_runtime_1.jsxs)("p", { children: ["We have removed ", (0, jsx_runtime_1.jsx)("b", { children: bicycleList }), " you have listed on ", aggregator, " as you'll automatically be covered for bicycles inside your home."] }));
        }
        else {
            var cheapBicycleList = this.prepareDynamicProductListString(cheapBicycles);
            return ((0, jsx_runtime_1.jsxs)("p", { children: ["We have removed ", (0, jsx_runtime_1.jsx)("b", { children: cheapBicycleList }), " you have listed on ", aggregator, " as you'll automatically get cover up to \u00A3350 for bicycles away from the home."] }));
        }
    };
    AnnualHomeRemovedBicyclesWidget.prototype.prepareDynamicProductListString = function (bicycles) {
        var itemDescriptions = bicycles.map(function (item) { return item.description; });
        var itemCount = bicycles.length;
        var descriptions;
        if (itemDescriptions.length === 1) {
            descriptions = itemDescriptions[0];
        }
        else {
            var lastItemDescription = itemDescriptions.pop();
            descriptions = "".concat(itemDescriptions.join(', '), " and ").concat(lastItemDescription);
        }
        return "".concat(itemCount, " bicycle").concat(itemCount > 1 ? "s" : "", " (").concat(descriptions, ")");
    };
    return AnnualHomeRemovedBicyclesWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeRemovedBicyclesWidget = AnnualHomeRemovedBicyclesWidget;
//# sourceMappingURL=AnnualHomeRemovedBicyclesWidget.js.map